'use client';

import React from 'react';

import { Box, BoxProps } from './box';

// Common props interface for all Stack variants
interface BaseStackProps extends BoxProps {
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  gap?: number | string;
  align?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
}

export type StackProps = BaseStackProps;

export type VStackProps = Omit<BaseStackProps, 'direction'>;

export type HStackProps = Omit<BaseStackProps, 'direction'>;

export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ direction = 'column', gap, align, justify, wrap, children, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        display="flex"
        flexDirection={direction}
        gap={gap}
        alignItems={align}
        justifyContent={justify}
        flexWrap={wrap}
        {...props}
      >
        {children}
      </Box>
    );
  }
);

Stack.displayName = 'Stack';

export const VStack = React.forwardRef<HTMLDivElement, VStackProps>(
  ({ gap, align = 'stretch', justify, wrap, children, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        display="flex"
        flexDirection="column"
        gap={gap}
        alignItems={align}
        justifyContent={justify}
        flexWrap={wrap}
        {...props}
      >
        {children}
      </Box>
    );
  }
);

VStack.displayName = 'VStack';

export const HStack = React.forwardRef<HTMLDivElement, HStackProps>(
  ({ gap, align = 'center', justify, wrap, children, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        display="flex"
        flexDirection="row"
        gap={gap}
        alignItems={align}
        justifyContent={justify}
        flexWrap={wrap}
        {...props}
      >
        {children}
      </Box>
    );
  }
);

HStack.displayName = 'HStack';
